import React from 'react';

import { Typography } from '@mui/material';

const Placeholder: React.FC = () => <Typography color="textSecondary">Not enough data</Typography>;

export default Placeholder;
